import { Injectable } from '@angular/core';
import { ApiService } from '@services/api.service';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import { GlobalAlertModel } from '../models/common';

@Injectable({
  providedIn: 'root',
})
export class GlobalAlertsRepository {
  constructor(private apiService: ApiService) {}

  public getGlobalAlerts(isShowLoader: boolean = true): Observable<GlobalAlertModel[]> {
    return this.apiService.get(`${environment.url.prefixCustoms}v2/global-alerts`, null, { isShowLoader });
  }

  public deleteGlobalAlert(id: number, isShowLoader?: boolean): Observable<void> {
    return this.apiService.delete(`${environment.url.prefixCustoms}v2/global-alerts/${id}`, null, { isShowLoader });
  }
}
